import { ResultAsync } from "neverthrow";
import { defineStore } from "pinia";
import md from "@/utils/mdParser";

const tooltipMetadata = JSON.parse(
	localStorage.getItem("tooltip-meta-data") || "{}",
);

export const useTooltipStore = defineStore("tooltip", {
	state: () => ({
		fileContent: {} as Record<string, unknown>,
		isHighlighted: {} as Record<string, boolean>,
		eTags: {} as Record<string, string>,
	}),
	actions: {
		async fetchContent(fileName: string) {
			const response = await ResultAsync.fromPromise(
				fetch(`/help-content/${fileName}.md`),
				(error) => new Error(`Failed to fetch content: ${error}`),
			);

			if (response.isErr()) {
				console.error(response.error);
				return response.error;
			}
			const eTag = response.value.headers.get("Etag") || "";

			const text = await response.value.text();
			const renderedContent = md.render(text);

			this.fileContent[fileName] = renderedContent;
			this.eTags[fileName] = eTag;
			this.isHighlighted[fileName] = tooltipMetadata[fileName] !== eTag;

			return text;
		},
		updateTooltipMetadata(fileName: string) {
			tooltipMetadata[fileName] = this.eTags[fileName];
			this.isHighlighted[fileName] = false;
			localStorage.setItem(
				"tooltip-meta-data",
				JSON.stringify(tooltipMetadata),
			);
		},
	},
});
